module.exports = [
  ...require('./_magicItemRawList_DMG_n'),
  require('./necklace_of_prayer_beads'),
]
